import { render, staticRenderFns } from "./NewReport.vue?vue&type=template&id=68992ef6&scoped=true"
import script from "./NewReport.vue?vue&type=script&lang=js"
export * from "./NewReport.vue?vue&type=script&lang=js"
import style0 from "./NewReport.vue?vue&type=style&index=0&id=68992ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68992ef6",
  null
  
)

export default component.exports